import React from "react";

export const initialContext = {
  activeContract: null,
  globalContractPage: 1, // pager
  activeContractPage: 1, // for current doc
  selectedContracts: [],
  totalPages: 1,
  receiptUrl: "", //blobUrl
  receiptPages: 0, // if 0 - contracts will start from 1
  receiptLayout: null, // for receipt sign
  // doc props
  showPage: false,
  pageRendered: false,
  selectedFieldIndex: -1,
}

const ContractsContext = React.createContext(initialContext)
export default ContractsContext;
